import { BsCalendarCheck, BsCheckCircleFill, BsLightningCharge, BsMoonStars } from "react-icons/bs";

export default function DeliveryOptions() {
  const coverage = "Limpopo: collected in town · Gauteng: door drop within 70km of Our Midrand Warehouse";
  const options = [
    {
      title: "Same Day Delivery",
      badge: "Fastest",
      summary: "Pay before 9am · Arrives by 5pm same day",
      icon: <BsLightningCharge />,
      accent: { icon: "bg-emerald-500", badge: "bg-emerald-100 text-emerald-800", check: "text-emerald-500", border: "border-emerald-200" },
      points: [
        "Pay order before 9am of Delivery Date",
        "Collected during office hours, within 3 hours of payment",
        "Reaches destination by 5pm same day",
        coverage,
      ],
    },
    {
      title: "Overnight Delivery",
      badge: "Most Popular",
      summary: "Pay before 2pm · Arrives by 8am next day",
      icon: <BsMoonStars />,
      featured: true,
      accent: { icon: "bg-purple-600", badge: "bg-purple-100 text-purple-800", check: "text-purple-500", border: "border-purple-400" },
      points: [
        "Pay order before 2pm of Pickup Date",
        "Collected during office hours, within 1 hour of payment",
        "Reaches destination by 8am the next day",
        coverage,
      ],
    },
    {
      title: "Next Friday Delivery",
      badge: "Best Value",
      summary: "Pay before 4pm Thursday · Arrives Saturday 1pm",
      icon: <BsCalendarCheck />,
      accent: { icon: "bg-amber-500", badge: "bg-amber-100 text-amber-800", check: "text-amber-500", border: "border-amber-200" },
      points: [
        "Pay order before 4pm, Thursday",
        "Collected during office hours, within 3 hours of payment",
        "Reaches destination by next Saturday at 1pm",
        coverage,
      ],
    },
  ];

  return (
    <section className="bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-5 py-16 md:py-20">
        <div className="text-center mb-12">
          <p className="text-sm font-medium uppercase tracking-widest text-purple-600 mb-2">Delivery Options</p>
          <h2 className="text-3xl md:text-4xl text-gray-900 mb-3">Service Level Agreements</h2>
          <p className="text-gray-600 text-lg max-w-xl mx-auto">Clear timelines so you always know what to expect</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-stretch">
          {options.map((option) => (
            <article
              key={option.title}
              className={`relative flex flex-col rounded-3xl border-2 bg-white p-6 transition-all hover:-translate-y-1 hover:shadow-xl ${option.accent.border} ${
                option.featured ? "shadow-xl shadow-purple-900/10 lg:-mt-3 lg:mb-3" : "shadow-sm"
              }`}
            >
              <div className="flex items-center justify-between gap-3 mb-5">
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-white text-xl ${option.accent.icon}`} aria-hidden="true">
                  {option.icon}
                </span>
                <span className={`text-xs font-medium px-3 py-1 rounded-full ${option.accent.badge}`}>{option.badge}</span>
              </div>
              <h3 className="text-xl text-gray-900">{option.title}</h3>
              <p className="text-sm font-medium text-gray-700 mt-1 mb-5">{option.summary}</p>
              <ul className="space-y-3 border-t border-gray-100 pt-5">
                {option.points.map((point) => (
                  <li key={point} className="flex items-start gap-2.5 text-sm text-gray-700">
                    <BsCheckCircleFill className={`mt-0.5 flex-shrink-0 ${option.accent.check}`} aria-hidden="true" />
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
